"use client";

import { useEffect } from "react";

import { buildAttribution } from "@/lib/attribution/build-attribution";
import { persistAttribution } from "@/lib/attribution/attribution-cookies";

/**
 * Captura a origem do visitante em qualquer página, não só em `/from/[slug]`.
 * Sem isso, todo tráfego de campanha com UTM chega como "direto".
 */
export function AttributionCapture() {
  useEffect(() => {
    const attribution = buildAttribution({
      slug: null,
      search: window.location.search,
    });
    if (attribution) persistAttribution(attribution);
  }, []);

  return null;
}
